<!--
    Desarrollado por: Ing. Wuilmer garcia
    // Fecha: 2021/04/04
    // Modificado por: 
    // Fecha de ultima Modificacion:    
    // Causa: 

    ///////////////////////////////////////////////////////////
-->

<template>
    <div>

        <v-form ref="formDatos" lazy-validation>
            <v-row  justify="end">
                <!--
                <v-col cols="12" sm="6" md="4" lg="3" class="py-0">
                    <v-select label="Plantilla" v-model="json_contenido.plantilla" @change="eventPlantilla(json_contenido.plantilla)"
                        :items="Plantillas" item-value="id" item-text="nombre_template">
                    </v-select>
                </v-col>            
                <v-btn  class="btn_block_style2 mr-2" dark tile @click="galerias()">Ver Galeria</v-btn>
                <v-btn  class="btn_block_style2 mr-2" dark tile @click="templates()">Ver Plantillas</v-btn>
                -->
                <!--
                    Pendiente Activar el visor
                <v-btn  class="btn_block_style2 mr-2" dark tile @click="visorDiapositivas(dataSet)">Ver Diapositiva</v-btn>
                -->
                <v-btn class="btn_style3 mr-4" dark tile @click="$emit('close')">Volver</v-btn>
            </v-row>


            <v-row>

                <v-col  sm="6" md="4" lg="3"  class="py-0">
                    <v-menu v-model="menu2" :close-on-content-click="false"
                        transition="scale-transition" offset-y
                        max-width="290px" min-width="290px" >

                        <template v-slot:activator="{ on }">
                            <v-text-field label="Fecha de Inicio" v-model="computedDateFormatted"
                                prepend-icon="fa-calendar-alt" 
                                readonly v-on="on" :rules="[validation.required]">
                            </v-text-field>
                        </template>

                        <v-date-picker v-model="json_contenido.fecha_inicio" 
                            no-title @input="menu2 = false" :max="maxDate"></v-date-picker>
                    </v-menu>
            
                </v-col>

                
                <v-col cols="12"  sm="6" md="4" lg="4"  class="py-0">
                <!-- <p>{{ radios || 'null' }}</p> -->
                <v-radio-group v-model="json_contenido.home" label="Ver en Home"   row>
                    <v-radio :label="`SI`" :value="true" color="teal"></v-radio>
                    <v-radio :label="`NO`" :value="false" color="error"></v-radio>
                </v-radio-group>
            </v-col>
                <v-col cols="12" sm="6" md="4" lg="3" class="py-0">
                    <v-select label="Categoria" v-model="json_contenido.id_categoria" 
                     :rules="[validation.selectReq]" @change="eventCategoria(json_contenido.id_categoria)"
                        :items="Categorias" item-value="id" item-text="desc_noticia_categoria">
                    </v-select>
                </v-col>

                <v-col cols="12" sm="4" md="4" lg="2" class="py-0">
                    <v-text-field type="number" v-model="json_contenido.orden_noticia" label="Orden" :rules="[validation.required]"></v-text-field>
                </v-col>
            </v-row>



            <!-- load edit events  -->
            <v-row v-if="gestorBackground" class="mx-2" :style="[{'background-color':color_fondo}]">
                <v-col cols="12" class="contenedor_texto mt-2">               
                    <v-col class="d-flex justify-space-between titulo-text mb-4">
                        <h4>Fondo</h4>
                        <v-btn fab dark x-small class="btn_style3" @click="gestorBackground=false"><v-icon dark>fa-times</v-icon></v-btn>
                    </v-col>

                    <v-color-picker v-model="color_fondo"></v-color-picker>
                </v-col>

                <v-row justify="end"> 
                    <v-btn class="btn_block_style2 mr-4" dark tile @click="saveBackground(columna, tag); gestorBackground=false">Agregar</v-btn>
                </v-row>
            </v-row>

            <!-- texto -->
            <v-row v-if="gestionEditor" class="mx-2" :style="[{'background-color':color_fondo}]">
                <v-col cols="12" class="contenedor_texto mt-2">                       
                    <v-col class="d-flex justify-space-between titulo-text mb-4">
                        <h4>{{tipoOperacion}}</h4>
                        <v-btn fab dark x-small class="btn_style3" @click="gestionEditor=false"><v-icon dark>fa-times</v-icon></v-btn>                    
                    </v-col>

                    <ckeditor v-model="editorData" :config="editorConfig"></ckeditor>
                </v-col>

                <v-row justify="end">
                    <v-btn v-if="evento=='agregar'" class="btn_block_style2" dark tile @click="saveText(tag)">Agregar</v-btn>
                    <v-btn v-if="evento=='editar'" class="btn_block_style2" dark tile @click="doneEditText(indexTarea)">Editar</v-btn>
                </v-row>
            </v-row>
                                    
        
            <!-- imagen  Temporal-->
            <v-row v-if="gestionImagen" class="mx-2" :style="[{'background-color':color_fondo}]">
                <v-col cols="12">
                    <div v-if="!image"> 
                        <h2>Selecione imagen</h2>  
                        <input type="file" name="subirArchivo" ref="myFileImagen" @change="onFileChange" accept=".jpg,.png,.gif" > 
                    </div> 

                    <v-row v-else justify="center">
                        <v-img contain max-width="500" max-height="300" :src="image"></v-img>  

                        <v-btn class="btn_eliminar float-right" fab x-small title="Eliminar" @click="removeImg">
                            <v-icon>fa-trash-alt</v-icon>
                        </v-btn> 
                    </v-row>
                </v-col>

                <v-row v-if="fileImg!=''" justify="end">
                    <v-btn v-if="evento=='agregar'" class="btn_block_style2" dark tile @click="saveImg">Agregar</v-btn>
                    <v-btn v-if="evento=='editar'" class="btn_block_style2" dark tile @click="saveEditImg(indexTarea)">Editar</v-btn>
                </v-row>
            </v-row>
            

            <!----- seccion agregar File -->
            <v-row v-if="gestionFile" class="mx-2" :style="[{'background-color':color_fondo}]">
                
                
                <v-col cols="12" sm="12" md="5" lg="4">
                    <v-text-field v-model="fileNombre" label="Descripción" :rules="[validation.required, validation.max100]"></v-text-field>
                </v-col>
                                
                <v-col cols="12" md="7" lg="8">
                    <h3>Documentos </h3>
                    <input type="file" ref="myFilePDF" @change="cargarFile" accept=".pdf, .xls, .xlsx, .doc, .docx, .ppt, .pptx,.txt">                
                    <span class="text-pdf">*tu archivo debe tener un tamaño no mayor a 10mb.</span><br>
                    <v-alert type="error" class="mt-2" v-if="errorSize">Ocurrio un error!!! el tamaño de su archivo no debe ser mayor a 10mb, el tamaño de su archivo es  {{tamanoFile}}mb.</v-alert>
                    <v-progress-linear v-if="barraPdf"  color="primary" indeterminate rounded height="6"></v-progress-linear>
                </v-col>
            
                <v-row v-if="nombre_archivo!=''" justify="end">
                    <v-btn v-if="evento=='agregar'" class="btn_block_style2" dark tile @click="saveFile" >Agregar</v-btn>
                    <v-btn v-if="evento=='editar'" class="btn_block_style2"  dark tile @click="saveEditFile(indexTarea)">Editar</v-btn>
                </v-row>
            </v-row>  

            <!-- Video -->
            <v-row v-if="gestionVideo" class="mx-2" :style="[{'background-color':color_fondo}]">
                <v-col cols="12">
                    <div v-if="!video"> 
                        <h2>Selecione Video</h2>  
                        <input type="file" name="subirArchivo" @change="onFileChangeVid" accept=".mp4,.ogg,.webm"> 
                    </div>  

                    <div v-else> 
                        <video width="320" height="180" controls poster="@/assets/mediavideo.png">
                            <source :src="video" type="video/mp4"> Tu navegador no soporta HTML5 video.
                        </video> 

                        <v-btn class="btn_eliminar" fab x-small title="Eliminar" @click="removid">
                            <v-icon>fa-trash-alt</v-icon>
                        </v-btn>  
                    </div>

                    <v-progress-linear v-if="barrarProgreso" color="primary" indeterminate rounded height="6"></v-progress-linear>
                </v-col>

                <v-row v-if="botonAgregarVideo" justify="end">
                    <v-btn v-if="evento=='agregar'" @click="saveVideo" class="btn_block_style2" dark tile>Agregar</v-btn>
                    <v-btn v-if="evento=='editar'" @click="saveEditVideo(indexTarea)" class="btn_block_style2" dark tile>Editar</v-btn>
                </v-row>
            </v-row>          


            <!-- galeria de Miniatura --> 
            <!--
            <v-row v-if="gestionGaleria" class="mx-2" :style="[{'background-color':color_fondo, 'cursor': 'pointer'}]">
                <v-col v-for="(item) of listGaleria" :key="item.id"  cols="3">
                    
                    <v-row  justify="center" class="ponter">
                        <v-img contain max-width="200" max-height="200" :src="`${SERVER}/${item.img_ruta+item.img_nombre}`" @click="saveGaleria(item)"></v-img>  
                    </v-row>
                    <v-row  justify="center">
                        <span class="text_galeria">{{item.img_descripcion}}</span>   
                    </v-row>
                </v-col>
                
            </v-row>
            -->
            <!-- END load edit events  -->
    


            <v-row class="mx-1">
                
                <v-col cols="12">
                    <v-card outlined class="text-center mb-3" :style="[{'background-color':json_contenido.color_fondo_titulo}]">
                        
                        <div  class="d-flex justify-space-between" >
                        
                            <span></span>
                            <div v-html="json_contenido.titulo"></div>

                            <span>
                                <v-btn class="btn_editar mr-2" fab x-small title="Editar" @click="activateElement('titulo')">
                                    <v-icon small>fa-pencil-alt</v-icon>
                                </v-btn>

                                <v-btn class="btn_palette mr-2" fab x-small title="Editar Color de Fondo" @click="activateBackground('titulo', -1)">
                                    <v-icon small>fas fa-palette</v-icon>
                                </v-btn>
                            </span>
                        </div>
                        
                    </v-card>


                </v-col>

                <!--  ************************ 
                    INICIO VISUALIZAR COLUMNA 
                ************************** -->
                
                <!--  ## START Contenido Diapositiva COL1    justify="space-between" -->
                <v-col cols="12" :class="ColumnaActiva01" class="pt-0" style="min-height:400px">     
                    <v-row class="d-flex justify-center mb-2" style="background-color:#0277bd; color: #fff !important;">
                        <h3>Columna 1</h3>
                    </v-row>         

                    <v-row class="d-flex justify-center">  
            
                        <v-btn class="btn_block_style2 mr-2 mb-2" small dark tile @click="activateElement('texto', 1)">
                            Texto<v-icon class="ml-3" >fa-text-width</v-icon>
                        </v-btn>
                        <v-btn class="btn_block_style2 mr-2 mb-2" small dark tile @click="activateImagen(1)">
                            Imagen<v-icon class="ml-3" >far fa-image</v-icon>
                        </v-btn>     
                        <!--           
                        <v-btn class="btn_block_style2 mr-2 mb-2" small dark tile @click="activateVideo(1)">
                            Video<v-icon class="ml-3" >far fa-play-circle</v-icon> 
                        </v-btn>   -->             
                        <v-btn class="btn_block_style2 mr-2 mb-2" small dark tile @click="activateDocument(1)">
                            Archivo<v-icon class="ml-3" >fas fa-file</v-icon>
                        </v-btn>   
                        <v-btn class="btn_block_style2 mr-2 mb-2" small dark tile  title="Editar Color de Fondo" @click="activateBackground('columna', 1)">
                            Color Fondo<v-icon class="ml-3" >fas fa-palette</v-icon>
                        </v-btn>

                

                    </v-row>

                    <div v-for="(item, index) of json_contenido.contDetalle" :key="item.id"> 

                        <v-card class="ma-2" :style="[{'background-color':json_contenido.color_fondo}]" >
                            <v-container>
                                <v-row justify="space-between">
                                    <v-col cols="10">



                                        <template v-if="item.tipo_contenido =='texto'">
                                            <span class="ma-2" v-html="item.nombre"></span> 
                                        </template> 


                                        <template v-if="item.tipo_contenido =='imagen'">
                                            <!-- <span>Imagen:{{SERVER+item.ruta_path}}</span> -->
                                            <v-row class="ma-2" justify="center"> 
                                                <v-img :src="SERVER+item.ruta_path" max-width="500" max-height="300" contain aspect-ratio="1"></v-img>
                                            </v-row>  
                                        </template>

                                        
                                        <template v-if="item.tipo_contenido =='imagenTemporal'">
                                            <v-row class="ma-2" justify="center"> 
                                                <v-img :src="SERVER+item.ruta_temporal" max-width="500" max-height="300" contain aspect-ratio="1"></v-img>
                                            </v-row>  
                                        </template>  
                                        

                                        
                                        <div v-if="item.tipo_contenido=='fileTemporal'">
                                         
                                            <span v-if="item.ruta_extension=='.doc' || item.ruta_extension=='.docx' " @click="downloadFile(SERVER+item.ruta_temporal)"
                                                class="d-flex justify-center" style="font-size: 32px; color: blue; cursor: pointer;">
                                                <i class="far fa-file-word"></i>
                                            </span>

                                            <span v-if="item.ruta_extension=='.xls' || item.ruta_extension=='.xlsx' " @click="downloadFile(SERVER+item.ruta_temporal)"
                                                class="d-flex justify-center" style="font-size: 32px; color: green; cursor: pointer;">
                                                <i class="far fa-file-excel"></i>
                                            </span>
                                            
                                            <span v-if="item.ruta_extension==='.pdf'"  @click="downloadFile(SERVER+item.ruta_temporal)"
                                                class="d-flex justify-center" style="font-size: 32px; color:red; cursor: pointer;">
                                                <i class="far fa-file-pdf"></i>
                                            </span>

                                             <span>
                                                {{item.nombre_img_seo}}
                                            </span>


                                        </div>

                                        <div v-if="item.tipo_contenido=='file'">

                                            <span v-if="item.ruta_extension=='.doc' || item.ruta_extension=='.docx' " @click="downloadFile(SERVER+item.ruta_path)"
                                                class="d-flex justify-center" style="font-size: 32px; color: blue; cursor: pointer;">
                                                <i class="far fa-file-word"></i>
                                            </span>

                                            <span v-if="item.ruta_extension=='.xls' || item.ruta_extension=='.xlsx' " @click="downloadFile(SERVER+item.ruta_path)"
                                                class="d-flex justify-center" style="font-size: 32px; color: green; cursor: pointer;">
                                                <i class="far fa-file-excel"></i>
                                            </span>
                                            
                                            <span v-if="item.ruta_extension==='.pdf'"  @click="downloadFile(SERVER+item.ruta_path)"
                                                class="d-flex justify-center" style="font-size: 32px; color:red; cursor: pointer;">
                                                <i class="far fa-file-pdf"></i>
                                            </span>
                                            <span>
                                                {{item.nombre_img_seo}}
                                            </span>

                                        </div>


                                        <template v-if="item.vid_path!='' && item.vid_path !=undefined">
                                            <center>
                                                <video width="320" height="180" controls poster="@/assets/mediavideo.png">
                                                    <source :src="item.vid_path" type="video/mp4">
                                                    Tu navegador no soporta HTML5 video.
                                                </video>
                                            </center> 
                                        </template> 
                                    </v-col>

                                    <v-col cols="2">
                                        <template>
                                            <div class="d-flex align-center justify-end">
                                                <v-btn v-if="item.tipo_contenido=='texto'" title="Editar" @click="editText(index, 1)" class="mx-2 pl-1" fab dark x-small color="warning" ><v-icon small >fa-pencil-alt</v-icon></v-btn>
                                                <v-btn v-if="item.tipo_contenido=='imagen' || item.tipo_contenido=='imagenTemporal' "  title="Editar imagen" @click="editImg(index, 1)" class="mx-2 pl-1" fab dark x-small color="orange"><v-icon small >fa-pencil-alt</v-icon></v-btn>
                                                <v-btn v-if="item.tipo_contenido=='video'"  title="Editar video" @click="editVideo(index, 1)" class="mx-2 pl-1" fab dark x-small color="info"><v-icon small >fa-pencil-alt</v-icon></v-btn>
                                                <v-btn v-if="item.tipo_contenido=='file'"   title="Editar Pdf" @click="editFile(index, 1)" class="mx-2 pl-1" fab dark x-small color="info"><v-icon small >fa-pencil-alt</v-icon></v-btn>                                            
                                                <v-btn title="Eliminar" @click="deleteObjeto(index, 1)" class="mx-2 pl-1" fab dark x-small color="error"><v-icon small >fas fa-trash-alt</v-icon></v-btn>
                                            </div>
                                        </template>  

                                    </v-col>

                                </v-row>
                            </v-container>
                        </v-card>
                
                    </div>
                    
                </v-col>
                <!--  ## END Contenido Diapositiva COL1  -->
                
                

                
            </v-row>

            <v-row justify="end"> 
                

                <v-btn  class="btn_block_style2 mt-7 mr-2" dark tile @click="saveItem()" >Guardar</v-btn>               
            </v-row>


            <!-- Visor Nuevo del Gestor de Contenido 
                Actualizado por el Ing Wuilmer 2020-01-25
            -->

            <!--
            <component :is="compName" :estadoModal="estadoModalConfig" @close="closeComponent"
                    :parametros="parametroConfigVisor">  
            </component>

            -->
    

            <!-- 
                parametros Item <code>{{this.parametros.item}}</code> 
                tempResponse: <code>{{tempResponse}}</code>
            Json : <code>{{json_contenido}}</code>
            -->

            <span v-if="test">
                <!--
                dataSet: <code>{{dataSet}}</code>
                parametros Item <code>{{this.parametros}}</code>  <br>
                Contenido: <code>{{json_contenido}}</code> <br>
                <br>
                -->                
               
                Detalle Contenido: <code>{{json_contenido.contDetalle}}</code>
                
                <br>
                Archivos Temporal: <code>{{archivoBack}}</code>          
                
                <!--
                <br>
                Session: <code>{{JSON.stringify(session)}}</code>          
                -->
            </span> 
 
        </v-form>
    </div>
</template>

<script>

    import axios, {API_URL} from "@/helpers/axios";
    import { validation } from "@/helpers/validator.js";
    /*
    

    import {mapActions, mapGetters, mapMutations } from 'vuex';
    import visorContenido from './visorGestorContenido';
    import loadTemplate from '../template/template';
    import loadGaleria from '../galeria/galeria';
    import '@/assets/css/galeria.css';

    */
    import { mapGetters, mapMutations } from 'vuex';

    export default {
        name:'NoticaFormulario',

        // props:['estadoComp' , 'parametros'],
        props:{
            parametros:{
                type:Object
            },
            estadoComp:{
                type:Boolean
            },
        },


        data(){
            return{
         
                SERVER : API_URL ,                
                extensionFile:'website/archivo/temporal/',
                uriTemporal :'website/archivo/temporal/',
                evento: null,

                menu2: false, 
                
                compName:"",
                estadoModalConfig: false,
                parametroConfigVisor : [],

                test :false,
                session: sessionStorage,
                paramComponente:{ 'id_submodulo':22, "id_modulo": 4}, 

                prueba : {},
                Categorias:{},     
                Plantillas:[],
                columna : -1,
                columna1: true,
                columna2: false,
                columna3: false,
                gestionEditor:false,
                gestionVideo: false,
                gestionImagen: false,
                gestionFile:false,
                gestorBackground: false,
                gestionGaleria: false,

                listGaleria:[],

                color_fondo:  "#B5E6FF",
                
                barraPdf:false,
                tipoOperacion:'',
                tag:'',
                editorData:'',

                botonAgregarVideo:false,
                barrarProgreso:false,
                orden_noticia:0,
                                   
                contador: 0,
                errorSize:false,
                tamanoFile:0,           
                editingImg: false,
                
                fileImg: '',
                fileVid: '',

                archivo:[],
                tempResponse : [],

                fileNombre: "",
                nombreFile:[],
                        
                indexTarea : -1,
             
                image: '',
                img_path: '',
                video: '',
                vid_path: '',
                file_path:'',

                nombre_archivo:'',
                json_contenido : {},
        
                archivoBack:{
                    archivo:[],
                },

 
                editorConfig: {
                    height : 120,
                    extraPlugins:
                        "colorbutton,font,colordialog,justify, tableresize,liststyle",
                    toolbar: [
                        { name: 'styles', items: [ 'Styles', 'Format', 'Font', 'FontSize' ] },
                        { name: 'basicstyles', items: [ 'Bold', 'Italic', 'Underline', 'Strike', 'Subscript', 'Superscript', '-' ] },
                        { name: 'colors', items: [ 'TextColor', 'BGColor' ] },
                        [ 'Undo', 'Redo' ], 
                            { name: 'document', items: [ 'Source', '-','Preview'   ] },
                        { name: 'tools', items: [ 'Maximize', 'ShowBlocks' ] },
                        '/',
                        { name: 'paragraph', items: [ 'NumberedList', 'BulletedList', '-', 'Outdent', 'Indent', '-', 'Blockquote', 'CreateDiv', '-', 'JustifyLeft', 'JustifyCenter', 'JustifyRight', 'JustifyBlock' ] },
                        { name: 'links', items: [ 'Link', 'Unlink', 'Anchor' ] },
                        { name: 'insert', items: ['Table', 'HorizontalRule', 'Smiley', 'SpecialChar', 'PageBreak', 'Iframe' ] },                        
                    ],        
                },


            }
        },


        computed: {
            ...mapGetters('login', [ 'componenteEvento']),        
       
            validation() {
                return validation;
            },

            ColumnaActiva01() {
                return (this.columna1) ?  'warning p-0' :'grey lighten-1'
            },
            ColumnaActiva02() {
                return (this.columna2) ?  'warning p-0' :'grey lighten-3'
            },
            ColumnaActiva03() {
                return (this.columna3) ?  'warning p-0' :'grey lighten-1'
            },


            // Maxima Fecha Calendario
            maxDate(){
                return  new Date().toISOString().substr(0, 10)               
            },

            computedDateFormatted () {
                return this.formatDate(this.json_contenido.fecha_inicio)
            },

        },

         mounted() {
            this.loadMain()
        },


        methods: {
            // ...mapActions('login',['parametroComponente'] ),
            ...mapMutations('mensajeSis', ['setEnviarMens']),

            //  ------- input tipo fecha  --------
            formatDate (date) {
                if (!date) return null

                const [year, month, day] = date.split('-')
                return `${day}/${month}/${year}`
            },

            //-- cargar Parametros de inicio del componente --
            async loadMain(){
                this.$refs.formDatos.resetValidation()
                await this.limpiarForm()
                this.getCategoria()
                
                // this.getTemplate()
                // this.calcularOrden() 

                // this.dataSet.miniatura = true                    
                console.log(`Evento: ${this.parametros.evento}`)       
                
                if(this.parametros.evento=='editar'){     

          
                    this.editItem(this.parametros) 
                }
                /*
                else{
                    console.log(`error de parametros `)

                }*/
                
            },


            async editItem (items) {

                try{
                    
                    console.log("Editando Contenido ")
                    console.log(items)
                    //this.json_contenido = JSON.parse(items.item)
                    this.json_contenido = items.item
                    this.json_contenido.id_usuario = sessionStorage.id

                    // let params ={id_empresa: this.session.id_empresa }
                    let response = await axios.post(`/website/noticia/getNoticiaDetalle/${items.item.id}`)
                    this.json_contenido.contDetalle = response.data

                }catch(error){
                    console.log(error)
                    this.setEnviarMens({tipo:"E", mensaje: `${error}`, tiempo:null})
                }

            

                // if(!item.json_contenido.plantilla){
                //    this.json_contenido.plantilla = -1
               // }
      
            },
  
            // open Visor
            visorDiapositivas(item){ 
                         
                const datosMiniatura = Object.assign(item, {evento:"agregar", miniatura:true, id_diapositiva:1});
                this.compName             = "visorContenido"
                this.estadoModalConfig    = true
                this.parametroConfigVisor = datosMiniatura
                // this.parametroConfigVisor = item
            
            },


            templates(){
                        
                this.compName             = "loadTemplate"
                this.estadoModalConfig    = true
                this.parametroConfigVisor = []
            
            },

            
            async getCategoria(){
            
                try{
                    
                    let params ={id_empresa: this.session.id_empresa }
                    let response = await axios.post("/website/notCategoria/get",{filtro:params})
                
                    let objectNew = JSON.parse(JSON.stringify(response.data))

                    objectNew.unshift({
                        "id":"",
                        "desc_noticia_categoria":"Seleccione ...",
                    })

                    this.Categorias = objectNew

                }catch(error){
                    console.log(error)
                    this.setEnviarMens({tipo:"E", mensaje: `${error}`, tiempo:null})
                }        

            },

            // Calcular Orden
            async eventCategoria(id){

                if(id>0  && this.parametros.evento=='agregar'){

                    try{                    
                        let params ={id_empresa: this.session.id_empresa }
                        let resp   = await axios.post(`/website/noticia/getNoticiaCount/categoria/${id}`,{filtro:params})   
                        this.json_contenido.orden_noticia = parseInt(resp.data.cantidad)+1;
                    }catch(error){
                        console.log(error)
                        this.setEnviarMens({tipo:"E", mensaje: `${error}`, tiempo:null})
                    }

                }
                

            },

             
         
            closeComponent(){
                this.estadoModalConfig    = false
                // this.getTemplate()            
            },


            /////////////////////////////
            // START global function  //
            activateColumna(columna){

                let error = true
                if(columna == 1){
                    this.columna1 = true
                    this.columna2 = false
                    this.columna3 = false
                    error = false
                }

                if(columna == 2){
                    this.columna1 = false
                    this.columna2 = true
                    this.columna3 = false
                    error = false
                }

                if(columna == 3){
                    this.columna1 = false
                    this.columna2 = false
                    this.columna3 = true
                    error = false
                }

                if(columna == -1){
                    this.columna1 = false
                    this.columna2 = false
                    this.columna3 = false
                    error = false
                }

                if(error){
                    return true  
                }else{                                    
                    return false
                }
                
            },

      
    
            async loadServerFile(archivo){
             
                try{
                    //console.log("Entro en load Server File 20210414 ")
                    // console.log("Archivo Adjunto ======>>>"+archivo)
                    let formData = new FormData(); 
                    formData.append('subirArchivo',  archivo)
                    formData.append("empresa", this.json_contenido.id_empresa)
                    // formData.append("categoria", this.json_contenido.id_categoria)
                    formData.append("usuario", this.session.id)
                    
                    let resp   = await axios.post(`/website/archivo/temporal`,formData, {
                        headers: { 'Content-Type': 'multipart/form-data' }
                    })   
     
                    return resp.data 
                }
                
                catch(e){

                    console.log("entro en error ===>"+e)      
                    this.setEnviarMens({tipo:"E", mensaje:`Error en cargar archivo en el Servidor`, tiempo:5000})
                    return false
                }   
                    
            },

            tempFileResp(resp){

                console.log(resp)
                this.tempResponse = [];  
                this.tempResponse.push({
                    rutaTemporal: resp.rutaTemporal,
                    nombreArchivo: resp.nombreArchivo,               
                    ext : resp.ext

                })
            },   


            clearElement(){          
                
                this.gestorBackground = false
                this.gestionVideo     = false
                this.gestionEditor    = false
                this.gestionFile   = false
                this.gestionImagen    = false          
                this.gestionGaleria   = false
            },
             

           

            // END global function     ////
            ///////////////////////////////


            activateElement(item, columna){

                this.activateColumna(columna)
                this.clearElement()
                this.tag = item
                this.evento = "agregar"
               

                if(item==='titulo')
                {                   
                    this.gestionEditor = true
                    this.tipoOperacion = 'TITULO'
                    this.editorData =  this.json_contenido.titulo
                    this.color_fondo = this.json_contenido.color_fondo_titulo
                }
                
        

                if(item==='texto')
                {   
                    this.loadFondoTexto(columna)

                        this.gestionEditor = true
                        this.tipoOperacion = 'TEXTO PARA CONTENIDO'
                        this.editorData = '<p>ESCRIBE AQUI EL TEXTO</p>'
                        this.color_fondo = '#FFFFFF'

                    /*
                    if(this.json_contenido.plantilla == -1){
                        this.gestionEditor = true
                        this.tipoOperacion = 'TEXTO PARA CONTENIDO'
                        this.editorData = '<p>ESCRIBE AQUI EL TEXTO</p>'
                        this.color_fondo = '#FFFFFF'
                    }else{
                        this.loadTextoPlantilla(columna)
                    }
                    */
                
                }

            },


            loadFondoTexto(columna){
                if(columna == 1){
                    this.color_fondo =   this.json_contenido.color_fondo
                }



            }, 
 
                    

            loadTextoPlantilla(columna){

                let result = this.Plantillas.filter(item => item.id ==  this.json_contenido.plantilla)
                let js =  JSON.parse(result[0].json_contenido);
                this.gestionEditor = true
                this.tipoOperacion = 'TEXTO PARA CONTENIDO'
                                          
                if(columna == 1){
                    this.editorData = js.seccion1[0].nombre                      
                    }

                if(columna == 2){
                    this.editorData = js.seccion2[0].nombre2
                }

                if(columna == 3){
                    this.editorData = js.seccion3[0].nombre3
                }                

            },


    
            addColumnaText(){
                let error = true

                if(this.editorData){
                    error = false
                    this.json_contenido.contDetalle.push({
                            id:"",
                            id_contenido:"",
                            tipo_contenido:"texto",
                            nombre: this.editorData,
                            nombre_img_seo:"",
                            ruta_path:"",
                            ruta_temporal:"",
                            ruta_extension:"",
                            fila:0,
                            columna:0,
                            color_fondo:"",
                            color_texto:"",
                            background:"",
                            orden_noticia:0,
                            estado:true,

                    })
                }            



                if(error){            
                    this.setEnviarMens({tipo:"E", mensaje: `Debe seleccionar una columna`, tiempo:null})         
                }
                
                else{
                    this.gestionEditor = false
                    this.editorData    = "" 
                }            
            },


            saveText(tag){
                
                if(tag === 'titulo'){
                    this.json_contenido.titulo = this.editorData
                    this.gestionEditor=false
                }
              
            
                if(tag === 'texto'){  
                    this.addColumnaText()    
                }
            },


            editText(index, columna){
                /*
                error = false
                    this.json_contenido.contDetalle.push({
                            id:"",
                            id_contenido:"",
                            tipo_contenido:"texto",
                            nombre: this.editorData,
                            nombre_img_seo:"",
                            ruta_path:"",
                            ruta_extension:"",
                            fila:0 ,
                            columna:0,
                            color_fondo:"",
                            color_texto:"",
                            background:"",
                            orden_noticia:0,
                            estado:true,
                    })
                */
                
                this.tag =  "texto"
                this.evento = "editar"
                this.gestionEditor = true
                this.indexTarea = index
                let error = this.activateColumna(columna) 

                // this.editorData = this.json_contenido.contDetalle[index].nombre 
                this.editorData = this.json_contenido.contDetalle[index].nombre 
                this.color_fondo = this.json_contenido.color_fondo           

                if(error){
                    this.setEnviarMens({tipo:"W", mensaje: `Error en editar Texto`, tiempo:null})
                }
                
            },
            
            doneEditText: function(index){  
                this.gestionEditor = false                
                this.json_contenido.contDetalle[index].nombre = this.editorData

            },

            // END edit text  //
            ////////////////////



      
            onFileChange(e) {
                var files = e.target.files || e.dataTransfer.files;
                if (!files.length)
                return;
                this.fileImg=  files[0]                
                this.createImage(files[0]);

                console.log(files[0])

            },

            createImage(file) {
                
                var reader = new FileReader();
                var vm = this;
                reader.onload = (e) => {
                    vm.image = e.target.result;
                };
                reader.readAsDataURL(file);
            },

            
            activateImagen: function(columna){

            
                if(this.json_contenido.id_categoria ==  "" ||this.json_contenido.id_categoria ==  undefined ){                    
                    this.setEnviarMens({tipo:"E", mensaje:"Debe de selecionar una categoria", tiempo:null}) 
                   
                }else{

                    this.activateColumna(columna) 
                    this.clearElement()
                    this.gestionImagen = true
                    this.evento = "agregar"
                }
               
                
            },



            activateVideo: function(columna){
                this.activateColumna(columna) 
                this.clearElement()
                this.gestionVideo = true
                this.evento = "agregar"

            },
            
            activateDocument: function(columna){
                this.activateColumna(columna) 
                this.clearElement()
                this.gestionFile = true
                this.evento = "agregar"

            },



            activateBackground(tag, columna){
                this.columna = columna
                this.tag = tag
                this.clearElement()
                let error = true

                if (tag == "titulo" && columna == -1){                    
                    this.color_fondo = this.json_contenido.color_fondo_titulo
                    error = false
                }

                if(columna == 1){
                    this.color_fondo = this.json_contenido.color_fondo
                    error = false
                }

                if(columna == 2){
                    this.color_fondo = this.json_contenido.color_fondo
                    error = false
                }

                if(columna == 3){
                    this.color_fondo = this.json_contenido.color_fondo
                    error = false
                }
                
                if(error){
                    this.setEnviarMens({tipo:"S", mensaje: `Error interno en configuración fondo`, tiempo:null})
                }else{
                    this.gestorBackground = true
                    this.activateColumna(columna)
                    
                }
            },



                  
            saveBackground(columna, tag){

                if (tag == "titulo" && columna == -1){                    
                    this.json_contenido.color_fondo_titulo = this.color_fondo                     
                }

                      

                if(columna == 1){
                    this.json_contenido.color_fondo = this.color_fondo 
                }


            },



            async saveImg(){
                let resp = await this.loadServerFile(this.fileImg)  
                await this.tempFileResp(resp)
                this.addColumnaImagen()                                
                 
            },


            async saveGaleria(item){

                this.gestionGaleria = false              
               
                if(this.columna1){
                    this.json_contenido.seccion1.push({
                        taskid: '',  
                        nombre: '',
                        nombreimg: `${item.img_nombre}`,
                        img_path:  `/${item.img_ruta+item.img_nombre}`,
                        img_destino: `/${item.img_ruta+item.img_nombre}`,
                        nombrevid: '',
                        vid_path: '',
                        estado: false,
                        name_file:'',
                        file_path:'',
                    })
               
                }

                if(this.columna2){
                    this.json_contenido.seccion2.push({
                        taskid2: '',
                        nombre2: '',
                        nombreimg2: `${item.img_nombre}`,
                        img_path2:  `/${item.img_ruta+item.img_nombre}`,
                        img_destino2: `/${item.img_ruta+item.img_nombre}`,
                        nombrevid2: '',
                        vid_path2: '',
                        estado2: false,
                        name_file2:'',
                        file_path2:'',
                    })
                  
                }

                if(this.columna3){
                    this.json_contenido.seccion3.push({
                        taskid3: '',
                        nombre3: '', 
                        nombreimg3: `${item.img_nombre}`,
                        img_path3:  `/${item.img_ruta+item.img_nombre}`,
                        img_destino3: `/${item.img_ruta+item.img_nombre}`,
                        nombrevid3: '',
                        vid_path3: '',
                        estado3: false,
                        file_path3:'',
                        name_file3:'',
                    })                    
            
                }                
                
            },


            removeImg(){
                this.image    = ''
                this.fileImg  = ''
                this.img_path = ''
            },


            //video upload 
            onFileChangeVid(e) {
                var files = e.target.files || e.dataTransfer.files;
                if (!files.length)
                return;
                this.botonAgregarVideo = true
                this.fileVid=  files[0]
            },



            ///###################################################################
            //////////////////// funciones para carga de Documentos PDF //////////
            //####################################################################
            /********funcion para cargar pdf */
            cargarFile(e) {
                var files = e.target.files || e.dataTransfer.files;
                if (!files.length)
                return;
                this.nombreFile =  files[0]
                this.nombre_archivo = files[0].name
                let sizeFile = files[0].size;
                // 10 MB
                if(sizeFile>9765625){ 
                    this.errorSize = true
                    this.$refs.myFileInputPdf.value = '';
                    var numero =  sizeFile/1048576;
                    this.tamanoFile = numero.toFixed(2);
                }

            },


         

            async saveFile(){

                this.barraPdf = true
                let resp = await this.loadServerFile(this.nombreFile)  
                await this.tempFileResp(resp)
                 this.addColumnaFile()   
                this.barraPdf = true

        },



        editFile(index, columna){

            this.evento = "editar"
            this.indexTarea = index
            this.fileNombre =   this.json_contenido.seccion1[index].nombre
            this.clearElement()
            this.gestionFile = true
            let error = this.activateColumna(columna)   

            if(error){
                this.setEnviarMens({tipo:"W", mensaje: `Error en editar Documento`, tiempo:null})
            }
    
        },

        async saveEditFile(index){

            let resp = await this.loadServerFile(this.nombreFile)  
            let error = true
        
            if((this.columna1) || (this.columna2) || (this.columna3)){
                this.tempFileResp(resp)
                error = false
            }

            if(error == false){                    
                this.editColumnaFile(index)
            }else{
                this.setEnviarMens({tipo:"E", mensaje:`Debe especificar la columna para guardar el Documento`, tiempo:5000})
            } 

        },


         //////////////////////// FIN ////////////////////////////

            
           
            //------resetear variables  //////
            resetVar(){
                this.image = '';
                this.img_path = '';
                this.video = '';
                this.vid_path = '';
                this.file_path = "";
            },
            //************************//////




            addColumnaImagen(){
                // let error = true
                let error         = false
                

                let nombreArchivo = this.tempResponse[0].nombreArchivo
                let rutaTemporal  = `${this.uriTemporal}${nombreArchivo}`
                let rutaDestino   = `website/archivo/noticia/cliente/${this.json_contenido.id_empresa}/categoria/${this.json_contenido.id_categoria}/${nombreArchivo}`
                let extension     =  this.tempResponse[0].ext

                this.json_contenido.contDetalle.push({
                    id:"",
                    id_contenido:"",
                    tipo_contenido:"imagenTemporal",
                    nombre: `${nombreArchivo}`,
                    nombre_img_seo:"",
                    ruta_path: rutaDestino,
                    ruta_temporal: rutaTemporal,
                    ruta_extension: extension,
                    fila:0,
                    columna:0,
                    color_fondo:"",
                    color_texto:"",
                    background:"",
                    orden_noticia:0,
                    estado:true,
                })
               

                

                if(error){
                    this.setEnviarMens({tipo:"E", mensaje: `Debe seleccionar una columna`, tiempo:null})       
                }else{
                    this.image = ""
                    this.fileImg = ''
                                     
                    this.gestionImagen = false;
                    this.resetVar();
                }
            },
    
    
            editColumnaImagen(index){
                let error = false
                console.log(index)

                let nombreArchivo = this.tempResponse[0].nombreArchivo
                let rutaTemporal  = `${this.uriTemporal}${nombreArchivo}`
                let rutaDestino   = `website/archivo/noticia/cliente/${this.json_contenido.id_empresa}/categoria/${this.json_contenido.id_categoria}/${nombreArchivo}`
                let extension     =  this.tempResponse[0].ext

                this.json_contenido.contDetalle[index].tipo_contenido="imagenTemporal"
                this.json_contenido.contDetalle[index].nombre = `${nombreArchivo}`
                this.json_contenido.contDetalle[index].nombre_img_seo =""
                this.json_contenido.contDetalle[index].ruta_path = rutaDestino
                this.json_contenido.contDetalle[index].ruta_temporal= rutaTemporal
                this.json_contenido.contDetalle[index].ruta_extension = extension
                this.json_contenido.contDetalle[index].fila=0
                this.json_contenido.contDetalle[index].columna=0

                if(error){
                    this.setEnviarMens({tipo:"E", mensaje: `Debe seleccionar una columna`, tiempo:null})       
                }else{
                    this.image = ""
                    this.fileImg = ''
                    this.gestionImagen = false;
                    this.resetVar()                    
                }

            },
        


            addColumnaVideo(){

                let error           = true
                let nombreVideo     = this.tempResponse[0].nombreArchivo
                let rutaTemporal    =  `${this.extensionFile}${this.tempResponse[0].rutaDestino}${this.tempResponse[0].nombreArchivo}`
                let rutaDestino     =  `${this.tempResponse[0].uri}${this.tempResponse[0].nombreArchivo}`

                if(this.columna1){
                    this.json_contenido.seccion1.push({
                        taskid: '',
                        nombre: '',
                        nombreimg: '',
                        img_path: '',
                        nombrevid: nombreVideo,
                        vid_path:  rutaTemporal,
                        vid_destino: rutaDestino,
                        estado: false,
                        name_file:'',
                        file_path:'',
                    })
                    error = false                
                }

                if(this.columna2){
                    this.json_contenido.seccion2.push({
                        taskid2: '',
                        nombre2: '',
                        nombreimg2: '',
                        img_path2: '',
                        nombrevid2: nombreVideo,
                        vid_path2:  rutaTemporal,
                        vid_destino2: rutaDestino,
                        estado2: false,
                        name_file2:'',
                        file_path2:'',
                    })
                    error = false                    
                }

                if(this.columna3){
                    this.json_contenido.seccion3.push({
                        taskid3: '',
                        nombre3: '',
                        nombreimg3: '',
                        img_path3: '',
                        nombrevid3: nombreVideo,
                        vid_path3:  rutaTemporal,
                        vid_destino3: rutaDestino,
                        estado3: false,
                        file_path3:'',
                        name_file3:'',
                    })                    
                    error = false
                } 

                if(error){
                    this.setEnviarMens({tipo:"E", mensaje: `Debe seleccionar una columna`, tiempo:null})         
                }
                else{
                    this.resetVar()
                    this.gestionVideo = false;  

                }
            },


            editColumnaVideo(index){
                
                let error           = true  
                let nombreVideo     = this.tempResponse[0].nombreArchivo
                let rutaTemporal    = `${this.extensionFile}${this.tempResponse[0].rutaDestino}${this.tempResponse[0].nombreArchivo}`
                let rutaDestino     = `${this.tempResponse[0].uri}${this.tempResponse[0].nombreArchivo}`


                if(this.columna1){
                    this.json_contenido.seccion1[index].nombrevid   = nombreVideo
                    this.json_contenido.seccion1[index].vid_path    = rutaTemporal
                    this.json_contenido.seccion1[index].vid_destino = rutaDestino
                    error = false                
                }

                if(this.columna2){                    
                    this.json_contenido.seccion2[index].nombrevid2   = nombreVideo
                    this.json_contenido.seccion2[index].vid_path2    = rutaTemporal
                    this.json_contenido.seccion2[index].vid_destino2 = rutaDestino
                     error = false                    
                }

                if(this.columna3){
                    this.json_contenido.seccion3[index].nombrevid3   = nombreVideo
                    this.json_contenido.seccion3[index].vid_path3    = rutaTemporal
                    this.json_contenido.seccion3[index].vid_destino3 = rutaDestino
                    error = false
                } 

                if(error){
                    this.setEnviarMens({tipo:"E", mensaje: `Debe seleccionar una columna`, tiempo:null})         
                }

                else{
                    this.resetVar()
                    this.gestionVideo = false;               
                }
            },




            addColumnaFile(){
                // let error = true
                let error         = false
                let nombreArchivo = this.tempResponse[0].nombreArchivo
                let rutaTemporal  = `${this.uriTemporal}${nombreArchivo}`
                let rutaDestino   = `website/archivo/noticia/cliente/${this.json_contenido.id_empresa}/categoria/${this.json_contenido.id_categoria}/${nombreArchivo}`
                let extension     =  this.tempResponse[0].ext

                this.json_contenido.contDetalle.push({
                    id:"",
                    id_contenido:"",
                    tipo_contenido:"fileTemporal",
                    nombre: `${nombreArchivo}`,
                    nombre_img_seo: this.fileNombre,
                    ruta_path: rutaDestino,
                    ruta_temporal: rutaTemporal,
                    ruta_extension: extension,
                    fila:0,
                    columna:0,
                    color_fondo:"",
                    color_texto:"",
                    background:"",
                    orden_noticia:0,
                    estado:true,
                })
               

                if(error){
                    this.setEnviarMens({tipo:"E", mensaje: `Debe seleccionar una columna`, tiempo:null})       
                }else{
                    
                    this.nombre_archivo = ''                    
                    this.nombreFile =  []
                    this.gestionFile = false
                    this.resetVar() 
                }
            },
    


            editColumnaFile(index){
                let error = false
                console.log(index)  

                let nombreArchivo = this.tempResponse[0].nombreArchivo
                let rutaTemporal  = `${this.uriTemporal}${nombreArchivo}`
                let rutaDestino   = `website/archivo/noticia/cliente/${this.json_contenido.id_empresa}/categoria/${this.json_contenido.id_categoria}/${nombreArchivo}`
                let extension     =  this.tempResponse[0].ext

                this.json_contenido.contDetalle[index].tipo_contenido="fileTemporal"
                this.json_contenido.contDetalle[index].nombre =  `${nombreArchivo}`, 
                this.json_contenido.contDetalle[index].nombre_img_seo = this.fileNombre
                this.json_contenido.contDetalle[index].ruta_path = rutaDestino
                this.json_contenido.contDetalle[index].ruta_temporal= rutaTemporal
                this.json_contenido.contDetalle[index].ruta_extension = extension
                this.json_contenido.contDetalle[index].fila=0
                this.json_contenido.contDetalle[index].columna=0

                if(error){
                    this.setEnviarMens({tipo:"E", mensaje: `Debe seleccionar una columna`, tiempo:null})       
                }else{
                     this.nombre_archivo = ''                    
                    this.nombreFile =  []
                    this.gestionFile = false
                    this.resetVar()                  
                }

            },



     
            // cargar json json_contenido
            async saveItem(){
                                 
                if (this.$refs.formDatos.validate()) {
                    // Validar Items 
                    if(this.json_contenido.contDetalle.length ==  0){                    
                        this.setEnviarMens({tipo:"E", mensaje:"Error en ingresar informacion requeridas para  el detalle del contenido", tiempo:null}) 
                        return false
                    }

                    if(this.json_contenido.id_categoria ==  "" ||this.json_contenido.id_categoria ==  undefined ){                    
                        this.setEnviarMens({tipo:"E", mensaje:"Debe de selecionar una categoria", tiempo:null}) 
                        return false
                    }

                    // let json_temporal = this.json_contenido
                    // JSON TEMPORAL DE VERDAD
                    let json_temporal = JSON.parse(JSON.stringify(this.json_contenido))

                    try
                    {
                        ////////////////////////////////////
                        // mover archivos temporales  //

                        for (const i in json_temporal.contDetalle) {

                            // ruta_path:"",   //  ruta_temporal:"",
                            if(json_temporal.contDetalle[i].tipo_contenido == "imagenTemporal" ||
                                json_temporal.contDetalle[i].tipo_contenido == "videoTemporal" ||
                                json_temporal.contDetalle[i].tipo_contenido == "fileTemporal" )
                            {

                                json_temporal.contDetalle[i].ruta_temporal= ""                            
                                this.archivoBack.archivo.push(
                                    {                             
                                        tipoContenido: json_temporal.contDetalle[i].tipo_contenido,
                                        nombreArchivo: json_temporal.contDetalle[i].nombre
                                    }
                                )
                            }

                        
                            if(json_temporal.contDetalle[i].tipo_contenido == "imagenTemporal"){
                                json_temporal.contDetalle[i].tipo_contenido = "imagen"                                
                            }

                            if(json_temporal.contDetalle[i].tipo_contenido == "videoTemporal"){
                                json_temporal.contDetalle[i].tipo_contenido = "video"
                            }

                            if(json_temporal.contDetalle[i].tipo_contenido == "fileTemporal"){
                                json_temporal.contDetalle[i].tipo_contenido = "file"
                            }
                        
                        }  

                        
                        let params = {contenido: json_temporal}
                        let resp = ""
                        if(this.parametros.evento == 'agregar'){   
                        
                            //console.log(" Guardar Contenido" + params)
                            resp = await axios.post('/website/noticia/', params) 
                            
                            // console.log(JSON.stringify(resp.data))                             
                            this.json_contenido = resp.data.data
                            // pendiente
                            this.moverArchivoTemporal()
                            this.setEnviarMens({tipo:resp.data.messageT,mensaje: resp.data.message, tiempo:null})
                            
                            

                        }
                        
                        if(this.parametros.evento == 'editar'){

                            resp = await axios.put("/website/noticia/"+this.parametros.item.id, params)
                            console.log(resp.data);                            
                            await this.moverArchivoTemporal()
                            this.setEnviarMens({tipo:resp.data.messageT,mensaje: resp.data.message, tiempo:null})
                        
                        }
                        

                    }                
                    catch(e){
                        this.setEnviarMens({tipo:e.mensajeT,mensaje: e.mensaje, tiempo:null})   
                        console.log(e)
                    }
               }else{
                    this.setEnviarMens({tipo:"W", mensaje: `Debe Ingresar todos los campos requeridos en el Formulario`, tiempo:null})
                }
                                        
            },


             limpiarForm(){
                
                this.json_contenido = { 
                                        id:- 1,
                                        id_usuario: sessionStorage.id,
                                        id_empresa:1,
                                        id_categoria:"",
                                        titulo: "<h1>ESCRIBE AQUI EL TITULO</h1>",
                                        titulo_color: "",
                                        titulo_background:"#FFFFFF",
                                        titulo_style:"",
                                        color_fondo_titulo:"#FFFFFF",
                                        fecha_inicio : "",
                                        fecha_fin:"",                                        
                                        color_fondo:"#7BBDE6",
                                        home:false,
                                        orden_noticia:null,
                                        estado_noticia: true,
                                        contDetalle:[],
                                    }
            },
            /*
             id_empresa: contenido.id_empresa,
                id_categoria : contenido.id_categoria,
                desc_noticia: contenido.desc_noticia, 
                fecha_inicio: contenido.fecha_inicio, 
                fecha_fin: contenido.fecha_fin, 
                titulo_color: contenido.titulo_color,
                titulo_background: contenido.titulo_background,
                titulo_style: contenido.titulo_style,
                orden_noticia_noticia: contenido.orden_noticia_noticia,  
                estado_noticia: contenido.estado_noticia,
                id_us_ing:  contenido.id_usuario
                */
           
            async moverArchivoTemporal(){
                try{
                    let params = this.archivoBack
                    console.log('--------------->'+JSON.stringify(params))
                    // await axios.post('/archivo/mover', params) 
                   let item = this.json_contenido
                   
                    await axios.post(`/website/archivo/moverArchivoNoticia/empresa/${item.id_empresa}/noticia/${item.id}/categoria/${item.id_categoria}`, params)
                     
                    // Pendiente 
                   // this.loadMain()
                    this.$emit("reloadComp",'noticia')
                    // this.$emit('close')
                    this.archivoBack.archivo = []

                }catch(e){
                    // this.$emit("actulizarData",this.dataSet)
                    console.log("Error =====> En mover Archivo ")                    
                    console.log(e)
                    // this.setEnviarMens({tipo:resp.data.messageT,mensaje: resp.data.message, tiempo:null})
                }
                  
             
            }, 
            //############################################# Api mover img y vid de temporal -> End
    


            // ver diapositiva ****/
            async verDiapositiva(item){
                //this.verificarColumnas(item)
                var id = item.id
                try{
                    let response = await axios.get("/administrativo/contenido/"+id+"");
                    this.prueba = response.data
                    this.diapost = JSON.parse(this.prueba[0].json_contenido)
                    //console.log('dipost====>>>'+JSON.stringify(this.diapost.seccion1));
                }                
                catch(error){
                    console.log(error);
                }
            },
            //########################################## diapositiva api end 



            // ****** EDITAR Imagen
            editImg(index, columna){

                this.evento = "editar"
                this.indexTarea = index    
                this.clearElement()            
                this.gestionImagen = true
                let error = this.activateColumna(columna)   

                if(error){
                    this.setEnviarMens({tipo:"W", mensaje: `Error en editar Imagen`, tiempo:null})
                }
        
            },

            async saveEditImg(index){

                let resp = await this.loadServerFile(this.fileImg)  
                await this.tempFileResp(resp)
                this.editColumnaImagen(index)    

            },


            async saveVideo(){
                let error = true 
                this.barrarProgreso = true
                let resp = await this.loadServerFile(this.fileVid)  
                this.barrarProgreso = false

                if((this.columna1) || (this.columna2) || (this.columna3)){
                    this.tempFileResp(resp)
                    error = false
                }
        
                if(error == false){
                    this.addColumnaVideo()    
                }
                
                else{
                    this.setEnviarMens({tipo:"E", mensaje:`Debe especificar la columna para guardar el Video`, tiempo:5000})
                }    
            },



            editVideo(index, columna){

                this.evento = "editar"
                this.indexTarea = index    
                            
                this.gestionVideo = true
                let error = this.activateColumna(columna)   

                if(error){
                    this.setEnviarMens({tipo:"W", mensaje: `Error en editar Video`, tiempo:null})
                }

            },



            async saveEditVideo(index){           

                let resp = await this.loadServerFile(this.fileVid)  
                let error = true
            
                if((this.columna1) || (this.columna2) || (this.columna3)){
                    this.tempFileResp(resp)
                    error = false
                }

                if(error == false){                    
                    this.editColumnaVideo(index)
                }
                
                else{
                    this.setEnviarMens({tipo:"E", mensaje:`Debe especificar la columna para guardar el Video`, tiempo:5000})
                } 

            },

   
            //################################### Editar seccion 1 end

            //################################## Eliminar Tareas ini
            
            deleteObjeto: function(index, columna){

                let error = true  
               
                if(columna == 1){
                    error = false 
                    this.json_contenido.contDetalle.splice(index, 1)  
                }

                if(columna == 2){
                    error = false 
                    this.json_contenido.seccion2.splice(index, 1)
                }


                if(error){
                    this.setEnviarMens({tipo:"E", mensaje:`Error en borrar objeto`, tiempo:5000})
                }
            
            },


            async downloadFile(url) {    
                const _url = url.split("/")  
                this.$Files.dowload({ url:url, filename:_url[_url.length-1]})
                /*
                try{
                    let response = await axios.get(url)

                    if(response){
                        this.$Files.dowload({ url:url, filename:_url[_url.length-1]})
                    }
        
                }catch (error) {

                    if (error) {
                        let resp = error.response.data
                        console.log(`***  RESPONSE MENSAJE : ${resp.message}` );  
                        this.setEnviarMens({tipo: resp.messageT, mensaje: ` ${resp.message}`, tiempo:null})   
                    }               
                }
                */
                
            },
            //################################## Eliminar Tareas end

            // //////////////////////////////
            //   FUNCIONES PENDIENTES     //
            // /////////////////////////////



            async getTemplate(){
            
                try{
                    let response   = await axios.post(`/administrativo/contenido/getTemplate/`,{filtro:{id_colegio:sessionStorage.id_colegio, tipo:1, estado_template:1}})

    
                    let objectNew = JSON.parse(JSON.stringify(response.data))

                    objectNew.unshift({
                        "id":-1,
                        "nombre_template":"Ninguno",
                    })

                    this.Plantillas = objectNew

                }catch(error){
                    console.log(error)
                    this.setEnviarMens({tipo:"E", mensaje: `${error}`, tiempo:null})
                }        

            },


            
            eventPlantilla(id){

                if(id>0){

                    let result = this.Plantillas.filter(item => item.id ==  id)
                    // let js =  result[0];
                    let js =  JSON.parse(result[0].json_contenido);
                    //console.log(js.titulo)
                    // console.log(js)
                   // let x = JSON.parse(result[0])
                    
                    this.json_contenido.titulo                = js.titulo

                    this.json_contenido.titulo_background     = js.titulo_background
                    this.json_contenido.color_fondo_titulo    = js.color_fondo_titulo
                    // this.json_contenido.color_fondo_col01     = js.color_fondo_col01
                    // this.json_contenido.color_fondo_col02     = js.color_fondo_col02
                    // this.json_contenido.color_fondo_col03     = js.color_fondo_col03

                }else{
                    this.limpiarForm()
                }               

            },




        },
    }
</script>



<style scoped>
    h4{
        color:#0D47A1;
    }

    .titulo-text{
        color: #045FB4;
        font-size: 23px;
        height: 50px;
        background: #fff;
        border-left: 5px solid #045FB4;
        padding-left: 11px;
        padding-top: 7px;
        box-shadow: 5px 5px 5px #D8D8D8;
    }

    .contenedor_texto{
        border: 2px solid #045FB4;
        margin-top: 28px;
        margin-bottom: 15px;
        background: #E6E6E6;
        border-radius: 11px;
    }

    input{
        margin-top: 15px;
        width: 100%;
        border: 1px dotted #045FB4;
        background: #fff;
        border-radius: 6px;
    }

    input[type=file]{
        color:#045FB4;
    }

    .titulo{
        position: relative;
    }
 
     .seccion-pdf{
        width: 100%;
        background: #ffffff;
        width: 100%;
        background: #ffffff;
        height: 100px;
        margin-top: 13px;
        padding-top: 25px;
        border: 2px dotted #1DABE0;
    }


    .seccion-pdf p{
        text-align: center;
    }

    .text-pdf{
        color:#045FB4;
        font-size: 12px;
        font-style: italic;
    }




</style>